import { http, HttpResponse } from 'msw'

import { allOrders } from 'app/mocks/data/operations/orders'

import {
    api,
    isNumeric,
    queryIntoArrayNumber,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'
import { searchParametersOrderApi } from 'app/utils/operations/orders'

import { OrdersRequest } from 'app/types/operations/order'

export const getAllOrders = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.operations.orders.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managerIdsFilter = searchParams.get(
            searchParametersOrderApi.MANAGERS,
        )

        const clientIdsFilter = searchParams.get(
            searchParametersOrderApi.CLIENTS,
        )

        const siteIdsFilter = searchParams.get(searchParametersOrderApi.SITES)
        const orderStatus = searchParams.get(searchParametersOrderApi.STATUS)

        let allOrdersFiltered = allOrders

        // Manager filter
        if (managerIdsFilter) {
            const managerIdsSplit = queryIntoArrayNumber(managerIdsFilter)

            allOrdersFiltered = allOrdersFiltered.filter((order) =>
                managerIdsSplit.includes(order.site.customer_name.client.id),
            )
        }

        // Client filter
        if (clientIdsFilter) {
            const clientIdsSplit = queryIntoArrayNumber(clientIdsFilter)

            allOrdersFiltered = allOrdersFiltered.filter((order) =>
                clientIdsSplit.includes(order.site.customer_name.id),
            )
        }

        // Site filter
        if (siteIdsFilter) {
            const siteIdsSplit = queryIntoArrayNumber(siteIdsFilter)

            allOrdersFiltered = allOrdersFiltered.filter((order) =>
                siteIdsSplit.includes(order.site.id),
            )
        }

        // Order status filter
        if (orderStatus) {
            allOrdersFiltered = allOrdersFiltered.filter(
                (order) => order.status === orderStatus,
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allOrdersFiltered.length > limit
                ? offset + limit
                : allOrdersFiltered.length

        const results = allOrdersFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allOrdersFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<OrdersRequest>({
            next,
            results,
        })
    },
)
